var usersLogin = {
  centered: function () {
    $('.page-center').matchHeight({
      target: $('html')
    });

    $(window).resize(function () {
      setTimeout(function () {
        $('.page-center').matchHeight({ remove: true });

        $('.page-center').matchHeight({
          target: $('html')
        });
      }, 100);
    });
  },

  ready: function () {
    usersLogin.centered();
  }
};

$(document).ready(usersLogin.ready);